<template>
  <SidePopup
    :title="title"
    v-on:close="onClose"
    @submit="onSubmit"
    routeback="/fornecedor/cadastro/agrupador/forma-pagamento"
  >
    <v-row no-gutters>
      <v-col cols="12">
        <FormField
          label="Nome do agrupador"
          v-model="form.descricao"
          :validation="$v.form.descricao"
        />
      </v-col>
      <v-col cols="12">
        <FormAutoComplete
          label="Formas de pagamento"
          placeholder="Selecione as formas de pagamento"
          v-model="form.formas_pagamento"
          :options="formasPagamentoOptions"
          :validation="$v.form.formas_pagamento"
          multiple
          clearable
        />
      </v-col>
      <v-col cols="12">
        <FormField
          label="Ordenação"
          typeField="number"
          v-model="form.ordenacao"
          :validation="$v.form.ordenacao"
          :personalizedMessage="errorMessageOrdenacao"
        />
      </v-col>
      <v-col cols="12">
        <FormSwitch v-model="form.ativo" label="Agrupador ativo" />
      </v-col>
    </v-row>
    <template v-slot:buttons>
      <FormButton text="Salvar" submit type="submissao" />
    </template>
  </SidePopup>
</template>

<script>
import SidePopup from "@/components/SidePopup";
import FormField from "@/components/form/FormField";
import FormSwitch from "@/components/form/FormSwitch";
import FormAutoComplete from "@/components/form/FormAutocomplete";
import FormButton from "@/components/form/FormButton";
import { required, minValue } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import {
  AGRUPADOR_PAGAMENTO_CREATE,
  AGRUPADOR_PAGAMENTO_UPDATE,
  AGRUPADOR_PAGAMENTO_LOAD
} from "@/store/actions/agrupadorPagamento";
import { FORMA_PAGAMENTO_LIST } from "@/store/actions/formaPagamento";

export default {
  name: "AgrupadorPagamentoForm",
  components: {
    SidePopup,
    FormField,
    FormSwitch,
    FormAutoComplete,
    FormButton
  },
  validations: {
    form: {
      descricao: { required },
      formas_pagamento: { required },
      ordenacao: { minValue: minValue(0) }
    }
  },
  data: () => ({
    mode: "add",
    form: {
      idagrupadorformapagto: null,
      descricao: "",
      formas_pagamento: [],
      ordenacao: 0,
      ativo: true
    }
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "getFormasPagamento"]),
    title() {
      return this.mode === "edit"
        ? "Editar agrupador de pagamento"
        : "Novo agrupador de pagamento";
    },
    formasPagamentoOptions() {
      return (this.getFormasPagamento || []).map(forma => ({
        value: forma.idformapagto,
        text: forma.description || forma.descricao
      }));
    },
    errorMessageOrdenacao() {
      return "A ordenação deve ser um número inteiro maior ou igual a 0";
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    carregarFormasPagamento() {
      this.$store
        .dispatch(FORMA_PAGAMENTO_LIST, {
          idfornecedor: this.getFornecedorId
        })
        .catch(() => {});
    },
    carregarAgrupador(id) {
      this.$store.dispatch(AGRUPADOR_PAGAMENTO_LOAD, id).then(resp => {
        this.form = {
          idagrupadorformapagto: resp.idagrupadorformapagto,
          descricao: resp.descricao,
          formas_pagamento: (resp.formas_pagamento || []).map(
            item => item.idformapagto
          ),
          ordenacao: resp.ordenacao || 0,
          ativo: resp.ativo !== false
        };
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;

      const payload = {
        ...this.form,
        ordenacao: Number(this.form.ordenacao) || 0,
        formas_pagamento: this.form.formas_pagamento || []
      };

      if (this.mode === "add") {
        this.$store.dispatch(AGRUPADOR_PAGAMENTO_CREATE, payload).then(() => {
          this.$vueOnToast.pop(
            "success",
            "Agrupador de pagamento cadastrado com sucesso"
          );
          this.onClose();
          this.$router.replace(
            "/fornecedor/cadastro/agrupador/forma-pagamento"
          );
        });
      } else {
        this.$store.dispatch(AGRUPADOR_PAGAMENTO_UPDATE, payload).then(() => {
          this.$vueOnToast.pop(
            "success",
            "Agrupador de pagamento atualizado com sucesso"
          );
          this.onClose();
          this.$router.replace(
            "/fornecedor/cadastro/agrupador/forma-pagamento"
          );
        });
      }
    }
  },
  created() {
    this.carregarFormasPagamento();
    const idRoute = this.$route.params.id;
    if (idRoute && idRoute !== "novo") {
      this.mode = "edit";
      this.carregarAgrupador(idRoute);
    }
  }
};
</script>
